<template>
  <div class="noWrap">
    {{ getIndValue }}
  </div>
</template>

<script>
export default {
  name: 'PadraoTemplateColumn',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    typeValue: [
      {
        value: true,
        text: 'Sim',
      },
      {
        value: false,
        text: 'Não',
      },
    ],
  }),
  computed: {
    getIndValue() {
      return this.typeValue.find(
        (item) => item.value === this.value,
      ).text;
    },
  },
};
</script>
